import React, {Component} from 'react';
import {withRouteData} from 'react-static';
import styled from 'styled-components';

import Halo from '../resources/images/network/halo.png';
import Circle1 from '../resources/images/network/circle1.png';
import Circle2 from '../resources/images/network/circle2.png';

import BGNormal from '../resources/images/network/bg.png';
import DotNormal from '../resources/images/network/dot.png';
import LabelNormal from '../resources/images/network/label.png';

import BGCtr from '../resources/images/network/bg-ctr.png';
import DotCtr from '../resources/images/network/dot-ctr.png';
import LabelCtr from '../resources/images/network/label-ctr.png';
import PurpleDot from '../resources/images/network/purpleDot.png';

const NetworkStyle = styled.div`
	overflow: hidden;
	
	.network-head {
		.columns {
			z-index: 1;
		}
	
		h2 {
			font-weight: 500;
			margin-top: 0;
			margin-bottom: 0;
		}
		
		p {
			margin-top: 0.9375rem;
			opacity: 0.5;
		}
	}
	
	.network-liveCTR, .network-liveRegular {
	    padding-bottom: 110%;
	}
	
	.network-content {
		h3 {
			font-size: 1.25rem;
			line-height: 1.5em;
			font-weight: 700;
			margin-top: 1.875rem;
		}
		
		p {
			margin-top: 0;
			opacity: 0.5;
		}
	}
	
	.network-image {
		img {
			-moz-user-select: none;
		    -webkit-user-select: none;
		    -ms-user-select: none;
		    user-select: none;
		    -webkit-user-drag: none;
		    user-drag: none;
		}
	
		padding-bottom: 0px;
		
		.live {
			padding-bottom: 110%;
		}
		
		.purpleDot {
			width: 2.07972%; 
			height: 1.74051%;
		}
		
		.bg {
		    width: 100%;
		    height: 100%;
		    top: 0;
		    left: 0;
		    
		    &-anim {
		        animation: anim-frame 2s ease infinite;
		    }
		}
		
		.dot {
			animation: anim-dot 2s ease infinite;
		}
		
		.halo {
			&-3 {
				animation: anim-halo 3s ease infinite;
			}
			&-4 {
				animation: anim-halo 4s ease infinite;
			}
			&-5 {
				animation: anim-halo 5s ease infinite;
			}
		}
		
		.purpledot {
			&-inner {
				animation: anim-purpledot-inner 2s normal infinite;
			}
			&-middle {
				animation: anim-purpledot-middle 2s normal infinite;
			}
			&-outer {
				animation: anim-purpledot-outer 2s normal infinite;
			}
		}
	}
	
	@keyframes anim-frame {
	    0% { opacity: 0; }
	    50% { opacity: 1; }
	    100% { opacity: 0; }
	}
	
	@keyframes anim-dot {
	    0% { transform: scale(0.8); }
	    50% { transform: scale(1.05); }
	    100% { transform: scale(0.8); }
	}
	
	@keyframes anim-halo {
	    0% { 
	        transform: scale(1.1);
	        opacity: 0.8; 
	    }
	    50% { 
	        transform: scale(2); 
	        opacity: 0.2;
	    }
	    100% { 
	        transform: scale(1.1);
	        opacity: 0.8; 
	    }
	}
	
	@keyframes anim-purpledot-inner {
	    0% { 
	        transform: scale(0.7);
	        opacity: 0; 
	    }
	    33% { 
	        transform: scale(1); 
	        opacity: 1;
	    }
	    100% { 
	        transform: scale(1.2);
	        opacity: 0; 
	    }
	}
	
	@keyframes anim-purpledot-middle {
		0% { 
	        transform: scale(0.7);
	        opacity: 0; 
	    }
	    10% { 
	        transform: scale(0.7);
	        opacity: 0; 
	    }
	    43% { 
	        transform: scale(1); 
	        opacity: 1;
	    }
	    100% { 
	        transform: scale(1.2);
	        opacity: 0; 
	    }
	}
	
	@keyframes anim-purpledot-outer {
		0% { 
	        transform: scale(0.7);
	        opacity: 0; 
	    }
	    20% { 
	        transform: scale(0.7);
	        opacity: 0; 
	    }
	    53% { 
	        transform: scale(1); 
	        opacity: 1;
	    }
	    100% { 
	        transform: scale(1.2);
	        opacity: 0; 
	    }
	}
`;

class Network extends Component {
	render() {
		
		return (
			<NetworkStyle>
				<div className="row medium-text-center network-head">
					<div className="columns medium-10 large-7 medium-centered">
						<h2>{this.props.network.head.header}</h2>
						<p>{this.props.network.head.description}</p>
					</div>
				</div>
				<div className="row network-content">
					<div className="columns medium-6 small-12">
						<div className="network-item">
							<div className="network-image network-liveRegular">
								<div className="live liveRegularNetwork active">

									{/* Base Frame */}
									<img src={BGNormal} className="bg" alt="regular network background" />
									<img src={BGNormal} className="bg bg-anim" alt="regular network background animation" />

									{/* Middle */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "20.2773%", top: "16.1392%"}} className="halo-4" alt="regular middle halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "40.8146%", top: "34.9367%"}} className="dot" alt="regular middle dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "42.7036%", top: "36.5965%"}} alt="regular middle circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "43.4489%", top: "37.3418%"}} alt="regular middle circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "46.6205%", top: "48.7342%"}} alt="regular middle label" />

									{/* Top */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "20.2773%", top: "-11.2342%"}} className="halo-3" alt="regular top halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "40.8146%", top: "7.56329%"}} className="dot" alt="regular top dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "42.7036%", top: "9.2231%"}} alt="regular top circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "43.4489%", top: "9.96835%"}} alt="regular top circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "46.6205%", top: "21.3608%"}} alt="regular top label" />

									{/* Top-Left */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "-6.23917%", top: "2.05696%"}} className="halo-5" alt="regular top-left halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "14.2981%", top: "20.8544%"}} className="dot" alt="regular top-left dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "16.1872%", top: "22.5142%"}} alt="regular top-left circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "16.9324%", top: "23.2595%"}} alt="regular top-left circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "20.104%", top: "34.6519%"}} alt="regular top-left label" />

									{/* Top-Right */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "46.4471%", top: "2.05696%"}} className="halo-5" alt="regular top-right halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "66.9844%", top: "20.8544%"}} className="dot" alt="regular top-right dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "68.8735%", top: "22.5142%"}} alt="regular top-right circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "69.6187%", top: "23.2595%"}} alt="regular top-right circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "72.7903%", top: "34.6519%"}} alt="regular top-right label" />

									{/* Bottom */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "20.2773%", top: "43.5127%"}} className="halo-4" alt="regular bottom halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "40.8146%", top: "62.3101%"}} className="dot" alt="regular bottom dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "42.7036%", top: "63.9699%"}} alt="regular bottom circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "43.4489%", top: "64.7152%"}} alt="regular bottom circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "46.6205%", top: "76.1076%"}} alt="regular bottom label" />

									{/* Bottom-Left */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "-6.23917%", top: "30.2215%"}} className="halo-3" alt="regular bottom-left halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "14.2981%", top: "49.019%"}} className="dot" alt="regular bottom-left dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "16.1872%", top: "50.6788%"}} alt="regular bottom-left circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "16.9324%", top: "51.4241%"}} alt="regular bottom-left circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "20.104%", top: "62.8165%"}} alt="regular bottom-left label" />

									{/* Bottom-Right */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "46.4471%", top: "30.2215%"}} className="halo-4" alt="regular bottom-right halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "66.9844%", top: "49.019%"}} className="dot" alt="regular bottom-right dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "68.8735%", top: "50.6788%"}} alt="regular bottom-right circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "69.6187%", top: "51.4241%"}} alt="regular bottom-right circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "72.7903%", top: "62.8165%"}} alt="regular bottom-right label" />

								</div>
							</div>
							<h3>{this.props.network.networkRegular.header}</h3>
							<p>{this.props.network.networkRegular.description}</p>
						</div>
					</div>
					<div className="columns medium-6 small-12">
						<div className="network-item">
							<div className="network-image network-liveCTR">
								<div className="live liveCTRNetwork active">

									{/* Base Frame */}
									<img src={BGCtr} className="bg" alt="ctr network background" />
									<img src={BGCtr} className="bg bg-anim" alt="ctr network background animation" />

									{/* Middle */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "20.2773%", top: "16.1392%"}} className="halo-3" alt="ctr middle halo" />
									<img src={DotNormal} style={{width: "18.9775%", height: "17.3259%", left: "40.8146%", top: "34.9367%"}} className="dot" alt="ctr middle dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "42.7036%", top: "36.5965%"}} alt="ctr middle circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "43.4489%", top: "37.3418%"}} alt="ctr middle circle 2" />
									<img src={LabelNormal} style={{width: "7.62565%", height: "3.00633%", left: "46.6205%", top: "48.7342%"}} alt="ctr middle label" />

									{/* Top */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "20.2773%", top: "-11.2342%"}} className="halo-4" alt="ctr top halo" />
									<img src={DotCtr} style={{width: "18.9775%", height: "17.3259%", left: "40.8146%", top: "7.56329%"}} className="dot" alt="ctr top dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "42.7036%", top: "9.2231%"}} alt="ctr top circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "43.4489%", top: "9.96835%"}} alt="ctr top circle 2" />
									<img src={LabelCtr} style={{width: "7.62565%", height: "3.00633%", left: "46.6205%", top: "21.3608%"}} alt="ctr top label" />

									{/* Top-Left */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "-6.23917%", top: "2.05696%"}} className="halo-3" alt="ctr top-left halo" />
									<img src={DotCtr} style={{width: "18.9775%", height: "17.3259%", left: "14.2981%", top: "20.8544%"}} className="dot" alt="ctr top-left dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "16.1872%", top: "22.5142%"}} alt="ctr top-left circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "16.9324%", top: "23.2595%"}} alt="ctr top-left circle 2" />
									<img src={LabelCtr} style={{width: "7.62565%", height: "3.00633%", left: "20.104%", top: "34.6519%"}} alt="ctr top-left label" />

									{/* Top-Right */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "46.4471%", top: "2.05696%"}} className="halo-5" alt="ctr top-right halo" />
									<img src={DotCtr} style={{width: "18.9775%", height: "17.3259%", left: "66.9844%", top: "20.8544%"}} className="dot" alt="ctr top-right dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "68.8735%", top: "22.5142%"}} alt="ctr top-right circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "69.6187%", top: "23.2595%"}} alt="ctr top-right circle 2" />
									<img src={LabelCtr} style={{width: "7.62565%", height: "3.00633%", left: "72.7903%", top: "34.6519%"}} alt="ctr top-right label" />

									{/* Bottom */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "20.2773%", top: "43.5127%"}} className="halo-5" alt="ctr bottom halo" />
									<img src={DotCtr} style={{width: "18.9775%", height: "17.3259%", left: "40.8146%", top: "62.3101%"}} className="dot" alt="ctr bottom dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "42.7036%", top: "63.9699%"}} alt="ctr bottom circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "43.4489%", top: "64.7152%"}} alt="ctr bottom circle 2" />
									<img src={LabelCtr} style={{width: "7.62565%", height: "3.00633%", left: "46.6205%", top: "76.1076%"}} alt="ctr bottom label" />

									{/* Bottom-Left */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "-6.23917%", top: "30.2215%"}} className="halo-4" alt="ctr bottom-left halo" />
									<img src={DotCtr} style={{width: "18.9775%", height: "17.3259%", left: "14.2981%", top: "49.019%"}} className="dot" alt="ctr bottom-left dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "16.1872%", top: "50.6788%"}} alt="ctr bottom-left circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "16.9324%", top: "51.4241%"}} alt="ctr bottom-left circle 2" />
									<img src={LabelCtr} style={{width: "7.62565%", height: "3.00633%", left: "20.104%", top: "62.8165%"}} alt="ctr bottom-left label" />

									{/* Bottom-Right */}
									<img src={Halo} style={{width: "59.9653%", height: "54.7468%", left: "46.4471%", top: "30.2215%"}} className="halo-4" alt="ctr bottom-right halo" />
									<img src={DotCtr} style={{width: "18.9775%", height: "17.3259%", left: "66.9844%", top: "49.019%"}} className="dot" alt="ctr bottom-right dot" />
									<img src={Circle1} style={{width: "15.338%", height: "14.0032%", left: "68.8735%", top: "50.6788%"}} alt="ctr bottom-right circle 1" />
									<img src={Circle2} style={{width: "13.6915%", height: "12.5%", left: "69.6187%", top: "51.4241%"}} alt="ctr bottom-right circle 2" />
									<img src={LabelCtr} style={{width: "7.62565%", height: "3.00633%", left: "72.7903%", top: "62.8165%"}} alt="ctr bottom-right label" />


									{/* Top Purple Dots */}
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "49.3934%", top: "34.4146%"}} className="purpledot-inner" alt="top purple dots inner" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "49.3934%", top: "30.9335%"}} className="purpledot-middle" alt="top purple dots middle" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "49.3934%", top: "27.2943%"}} className="purpledot-outer" alt="top purple dots outer" />

									{/* Top-Left Purple Dots */}
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "41.4386%", top: "38.6076%"}} className="purpledot-inner" alt="top-left purple dots inner" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "38.1366%", top: "36.8671%"}} className="purpledot-middle" alt="top-left purple dots middle" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "34.6845%", top: "35.0475%"}} className="purpledot-outer" alt="top-left purple dots outer" />

									{/* Top-Right Purple Dots */}
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "57.3482%", top: "38.6076%"}} className="purpledot-inner" alt="top-right purple dots inner" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "60.6502%", top: "36.8671%"}} className="purpledot-middle" alt="top-right purple dots middle" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "64.1023%", top: "35.0475%"}} className="purpledot-outer" alt="top-right purple dots outer" />

									{/* Bottom Purple Dots */}
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "49.3934%", top: "52.2943%"}} className="purpledot-inner" alt="bottom purple dots inner" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "49.3934%", top: "55.7753%"}} className="purpledot-middle" alt="bottom purple dots middle" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "49.3934%", top: "59.4146%"}} className="purpledot-outer" alt="bottom purple dots outer" />

									{/* Bottom-Left Purple Dots */}
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "41.4386%", top: "46.9937%"}} className="purpledot-inner" alt="bottom-left purple dots inner" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "38.1366%", top: "48.7342%"}} className="purpledot-middle" alt="bottom-left purple dots middle" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "34.6845%", top: "50.5538%"}} className="purpledot-outer" alt="bottom-left purple dots outer" />

									{/* Bottom-Right Purple Dots */}
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "57.3482%", top: "46.9937%"}} className="purpledot-inner" alt="bottom-right purple dots inner" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "60.6502%", top: "48.7342%"}} className="purpledot-middle" alt="bottom-right purple dots middle" />
									<img src={PurpleDot} style={{width: "2.07972%", height: "1.74051%", left: "64.1023%", top: "50.5538%"}} className="purpledot-outer" alt="bottom-right purple dots outer" />

								</div>
							</div>
							<h3 className="green">{this.props.network.networkCTR.header}</h3>
							<p>{this.props.network.networkCTR.description}</p>
						</div>
					</div>
				</div>
			</NetworkStyle>
		)
	}
}

export default withRouteData(Network)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Network.js